import React, { useCallback, useMemo } from "react";
import { Grid } from "semantic-ui-react";
import { SearchValue } from "../../../../components/SearchValue/SearchValue";

interface GenericIngredient {
  key: number;
  text: string;
  value: number;
  disabled?: boolean;
}

interface GenericIngredientFieldsProps {
  genericIngredient: string;
  setGenericIngredient: (value: string) => void;
  genericIngredients: GenericIngredient[];
}

interface SearchDataValue {
  id: number;
  title: string;
  disabled: boolean;
}

const GenericIngredientFields: React.FC<GenericIngredientFieldsProps> = ({
  genericIngredient,
  setGenericIngredient,
  genericIngredients
}) => {
  const prunedIngredients = useMemo(
    () =>
      genericIngredients.filter(
        ing => !ing.disabled || String(ing.value) === String(genericIngredient)
      ),
    [genericIngredients, genericIngredient]
  );

  const searchDataValues = useMemo<SearchDataValue[]>(
    () =>
      prunedIngredients.map(ingredient => ({
        id: ingredient.value,
        title: ingredient.text,
        disabled: ingredient.disabled ?? false
      })),
    [prunedIngredients]
  );

  const defaultDisplay = useMemo(
    () =>
      genericIngredients.find(ingredient => String(ingredient.value) === String(genericIngredient))
        ?.text ?? "",
    [genericIngredients, genericIngredient]
  );

  const handleSelectDetails = useCallback(
    (data: { result?: { id?: number } }) => {
      const pickedId = data?.result?.id;
      if (pickedId != null) setGenericIngredient(String(pickedId));
    },
    [setGenericIngredient]
  );

  return (
    <Grid.Column computer={8} tablet={8} mobile={16}>
      <SearchValue
        title="Ingredient Name"
        placeholder="Type to search ingredients"
        defaultValue={defaultDisplay}
        searchDataValues={searchDataValues}
        selectDetails={handleSelectDetails}
        checkOther={() => {}}
        noResultEnable
        noResultData={{ title: "ingredient not found" }}
        disable={false}
      />
    </Grid.Column>
  );
};

export default GenericIngredientFields;
